import { Checkbox } from "@mui/material";
import { useContext } from "react";

import { UnknownTransaction } from "../../../Type";
import ContextTable from "../../contextTable";

export default function SelectCheckbox({ description }: UnknownTransaction) {
	const { onSelectRow, selected } = useContext(ContextTable);

	return (
		<Checkbox
			sx={{ p: 0 }}
			checked={selected.includes(description)}
			onClick={(event) => {
				event.stopPropagation();
				onSelectRow(description);
			}}
			size='small'
		/>
	);
}
